<template>
    <div>
        <div class="card card-default">
            <div class="card-header border-0">Team members</div>
            <div class="card-body border-0">
                <div v-if="!loading">
                    <b-progress :max="num_seats" :value="team_members.length"></b-progress>
                    <p class="text-right small">{{team_members.length}} / {{num_seats}}</p>
                </div>
                <p>Add your whole team and deliver fast customer support together.</p>

                <div v-if="loading">
                    <img src="/loading.svg"> Loading
                </div>


                <ul class="list-group">
                    <template v-for="team_member in team_members">
                        <div class="list-group-item">
                            {{team_member.name}} &nbsp;&nbsp;
                            <span class="text-muted">{{team_member.email}}</span>

                            <button class="float-right btn btn-outline text-danger" title="Revoke access" @click="removeMember(team_member.id)" v-b-tooltip.hover>
                                <b-icon-x-circle></b-icon-x-circle>
                            </button>
                        </div>
                    </template>
                </ul>

                <div class="mt-4">
                    <template v-if="team_members && (num_seats > team_members.length)">
                        <b-button variant="primary" class=" mr-2" v-show="!isNewFormOpen" @click='toggleNewForm()'>Add</b-button>
                    </template>
                    <template v-else>
                        <b-button @click="upgradeNotification()" class=" mr-2" variant="primary">Add</b-button>
                    </template>
                </div>

                <div v-show="isNewFormOpen">
                    <validation-observer ref="observer" v-slot="{ passes }">
                        <form @submit.stop.prevent="passes(addMember)">
                            <hr/>
                            <label>Email address</label>
                            <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                                <b-form-input v-model="email"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <p>We will create a new InboxGPT account.</p>

                            <a class="btn btn-outline mt-2 mr-2" @click='toggleNewForm()'>Cancel</a>
                            <button type="submit" class="btn btn-primary  mt-2">Confirm</button>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from "../mixins/NotificationPop";
import UpgradeNotification
    from "../mixins/UpgradeNotification";

export default {
    mixins: [NotificationPop,UpgradeNotification],
    data: () => ({
        loading: true,
        team_members: null,
        isNewFormOpen: false,
        email: null,
        num_seats: 0,
        // account: {
        //     limits: {
        //         team_members: 0
        //     },
        //     limit_usage: {
        //         team_members: 0
        //     }
        // },
    }),
    async created() {
        // Fetch team data from API
        this.$http.get(`team/account`)
            .then(response => {
                this.num_seats = response.data.quantity
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                // Hide the loading spinner

            });

        this.$http.get('/teams/' + this.$auth.user().team_id + '/members')
            .then(({data}) => {
                this.loading = false
                this.team_members = data.data
            })
            .catch(error => {
                this.loading = true
                console.log(error.response)
                this.popNotification('Could not load your team_members', 'danger')
            })
    },
    methods: {
        toggleNewForm: function () {
            this.isNewFormOpen = !this.isNewFormOpen
        },

        addMember: function(e) {
            this.$http
                .post('/teams/' + this.$auth.user().team_id + '/members', {
                    email: this.email
                })
                .then(({ data }) => {
                    // add to list
                    console.log(data)
                    this.team_members.push({
                        id: data.data.id,
                        name: data.data.name,
                        email: data.data.email
                    });
                    // clear form and toggle
                    this.email = '';
                    this.isNewFormOpen = false;
                    this.popNotification('Team member added', 'success');
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.error) {
                        // handle specific error message from the server
                        const errorMessage = error.response.data.error;
                        this.popNotification(errorMessage, 'danger');
                    } else {
                        // handle generic error message
                        this.popNotification('Could not add team member', 'danger');
                    }
                });
        },

        removeMember: function(id) {
            if (!confirm('Are you sure you want to remove this user? Communication from/to this user will not be removed. The user does lose access to the account.')) {
                return false;
            }

            let index = this.team_members.findIndex(team_member => team_member.id === id);

            this.$http
                .delete('/teams/' + this.$auth.user().team_id + '/members/' + id)
                .then(({ response }) => {
                    this.popNotification('Team member removed', 'success');
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.error) {
                        // handle specific error message from the server
                        const errorMessage = error.response.data.error;
                        this.popNotification(errorMessage, 'danger');
                    } else {
                        // handle generic error message
                        this.popNotification('Could not remove user', 'danger');
                    }
                    console.error(error);
                });

            this.team_members.splice(index, 1);
        }

    }
}
</script>
